import { EditorialJourneyStep } from '../types/editorial-journey-step.type';

import ecoActorIllustration from '../../assets/img/picto/illu.png';
import gatheringIllustration from '../../assets/img/zero_fraise.png';
import invitationIllustration from '../../assets/img/picto/ordi.png';
import orderingIllustration from '../../assets/img/corbeille-4.png';
import trackingIllustration from '../../assets/img/zero_tomate.png';
import deliveryIllustration from '../../assets/img/picto/producteur.png';

// Contenu relevé sur la page legacy /c-c-m (src/views/Front/EcoActeurs/CCM.js).
export const GROUP_ORDER_HERO = {
  title: 'Comment ça marche ?',
};

// Le legacy écrit quatre de ces titres en minuscules et deux avec une capitale, sans qu'aucun
// `text-transform` ne l'explique : la casse est normalisée ici.
export const GROUP_ORDER_JOURNEY: EditorialJourneyStep[] = [
  {
    title: 'Je suis éco-acteur',
    illustration: ecoActorIllustration,
    illustrationAlt: 'Un éco-acteur et son panier',
    points: [
      'J’organise des commandes groupées de paniers bio.',
      'Je crée du lien et du partage.',
      'Je gagne des Eco-points.',
    ],
  },
  {
    title: 'Je rassemble',
    illustration: gatheringIllustration,
    illustrationAlt: 'Une fraise',
    points: [
      'Je communique auprès de mon entourage sur les commandes groupées que j’organise.',
      'Bio Culture m’accompagne dans ma démarche avec les moyens de communication adaptés.',
    ],
  },
  {
    title: 'Je lance mon invitation',
    illustration: invitationIllustration,
    illustrationAlt: 'Un ordinateur affichant une invitation',
    points: [
      'Je choisis le jour et l’heure auxquels je souhaite être livré.',
      'Je personnalise le texte proposé.',
      'J’envoie ma proposition de commande groupée à mes contacts.',
    ],
  },
  {
    title: 'On se fait plaisir !',
    illustration: orderingIllustration,
    illustrationAlt: 'Des corbeilles de fruits',
    points: [
      'Mes contacts passent commande en quelques clics, sans créer de compte.',
      'Ils paient par carte bancaire, sur un site sécurisé.',
      'Ils reçoivent un ticket de paiement sur leur boîte courriel.',
    ],
  },
  {
    title: 'Je suis la progression',
    illustration: trackingIllustration,
    illustrationAlt: 'Une tomate',
    points: [
      'Je suis en permanence le nombre de réponses et de commandes passées, grâce à mon tableau de bord.',
      'Je visualise en direct les Eco-points que je vais recevoir.',
      'Je peux relancer les plus distraits de mes invités en un clic.',
    ],
  },
  {
    title: 'Le jour J',
    illustration: deliveryIllustration,
    illustrationAlt: 'Un producteur livrant les paniers',
    points: [
      'Bio Culture me livre mes paniers bio.',
      'Mes participants viennent les récupérer dans le créneau que j’ai indiqué.',
      'Je reçois mes Eco-points, utilisables dès ma prochaine commande en bon d’achat ou en don alimentaire.',
    ],
  },
];

export const GROUP_ORDER_SUPPORT = {
  title: 'Bio Culture et moi',
  points: [
    'L’équipe de Bio Culture est à mon écoute pour m’aider et m’accompagner.',
    'Bio Culture m’invite à des rencontres « Eco-Acteurs » pour échanger, partager et déguster des fruits et légumes.',
  ],
};
